import { useLocation, useParams } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/24/outline";

import Button from "components/Button";
import { CARE_EMAIL, PHONE } from "constants/at-need";
import { formatPhoneNumber } from "helpers/phone";

export default function ArrangementAccessDenied() {
  const { caseId } = useParams<{ caseId: string }>();
  const location = useLocation();
  const caseDetailsHref = caseId ? `/cases/${caseId}${location.search}` : "/";

  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-oat">
        <LockClosedIcon className="h-8 w-8 text-evergreen" />
      </div>
      <h1 className="font-serif text-[34px] font-normal leading-[1.15] text-soil">
        Sorry, you don&apos;t have access to this page
      </h1>
      <p className="mt-3 text-lg text-soil">
        If you think this is an error, please reach out to our care team for
        assistance.
      </p>
      <div className="mt-8">
        <Button href={caseDetailsHref} variant="primary" size="lg">
          View case details
        </Button>
      </div>
      <p className="mt-6 text-base text-soil">
        Need help? Call us at{" "}
        <a
          href={`tel:${PHONE}`}
          className="font-semibold text-evergreen underline"
        >
          {formatPhoneNumber(PHONE)}
        </a>{" "}
        or email{" "}
        <a
          href={`mailto:${CARE_EMAIL}`}
          className="font-semibold text-evergreen underline"
        >
          {CARE_EMAIL}
        </a>
        .
      </p>
    </div>
  );
}
